/** @jsxImportSource @emotion/react */

import { formatCurrency } from "helpers/formatCurrency";
import { useRef } from "react";

import { useGetBalanceDV } from "api/user/query";
import { ReactComponent as RefreshIcon } from "assets/common/icons/refresh.svg";
import { GameMenuStyle } from "./index.style";

function GameMenu() {
  const { data, refetch, isFetching } = useGetBalanceDV();

  const modalRef = useRef<HTMLLIElement | null>(null);
  return (
    <li ref={modalRef} css={GameMenuStyle.index} id={"GameMenu"}>
      <div className="btn_memberPMenu">
        <span className="value">
          ${" "}
          <span className="ng-binding">
            {formatCurrency(Math.trunc(Number(data?.main_balance || 0))) || 0}
          </span>
        </span>
        <button
          type="button"
          className="btn-refresh"
          onClick={(e) => {
            e.stopPropagation();
            refetch();
          }}
          title="Refresh"
        >
          <RefreshIcon className={isFetching ? "spinning" : ""} />
        </button>
      </div>
    </li>
  );
}

export default GameMenu;
